<template>
    <div class="home-page">
		<Header></Header>
		<div class="">
			<div class="nav flex">
				<div class="back" @click="back">
					<img src="static/images/return.png" />
				</div>
				<span class="">{{$t('Question_List')}}</span>
			</div>
			<div class="question-list" :class="item.status=='2'||item.outcome==''?'cr999':''" v-for="(item,index) in list">
				<div class="title">
					{{index+1}}.{{item.title}}
				</div>
				<div class="answer">
					<span :class="{'cr00a651':item.correct==option[index1],'cred1c24':item.correct!=item.outcome&&item.outcome==option[index1]}" v-for="(item1,index1) in item.options.split('|')">{{item1}}</span>
				</div>
				<div class="answer-img por">
					<img :src="item.image" />
					<div class="dui">
						<img v-if="item.outcome==item.correct" src="static/images/dui.png" />
						<img v-if="item.outcome!=item.correct&&item.outcome!=''" src="static/images/cuo.png" />
						<img v-if="item.status=='2'||item.outcome==''" src="static/images/gantan.png" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Header from '../components/header'
import config from '../config.js'
export default {
    components:{
		Header
    },
    data() {

        return {
			notFound:false,
			list:[],
			option:['A','B',"C","D"],
			selectA:'A',
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		//console.log(this.$route.query.id);
		this.getHome();
	},
    methods: {
		back(){
			this.$router.go(-1);
		},
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			let data = {'token':localStorage.getItem('token'),uuid:localStorage.getItem('uuid'),'id':that.$route.query.id}
			that.$api.post('/core/learn',data,r =>{
				that.$parent.returnCode(r,function(){
					that.list = r.data
					that.$parent.loadModal(false);
                });

			})
		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/answeredList.vue